/**
 * cpPageTitle - Directive for set Page title - mata title
 */

(function() {
    'use strict';

    angular.module('caffeprint')
        .directive('cpPageTitle', cpPageTitle);

    cpPageTitle.$inject = ['$rootScope', '$timeout'];

    function cpPageTitle($rootScope, $timeout) {
        var titlePrefix = 'CP | ';
        if (config.siteId === 2){
            titlePrefix = 'Achjoj | ';
        } else if (config.siteId === 3){
            titlePrefix = 'Drukujnajtaniej | ';
        }

        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var prefix = titlePrefix;
                var defaultTitle = 'Panel administarora';

                function listener(event, toState, toParams, fromState, fromParams) {
                    var title;

                    if (toState.data && toState.data.title) {
                        title = prefix + toState.data.title;
                    } else {
                        title = prefix + defaultTitle;
                    }

                    $timeout(function() {
                        element.text(title);
                    });
                };

                $rootScope.$on('$stateChangeStart', listener);
            }
        }
    }
})();
